import { createPrescription } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  CreatePrescriptionRequestT,
  CreatedPrescriptionT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchCreatePrescription(
  userId: string,
  request: CreatePrescriptionRequestT,
  signal?: AbortSignal
): Promise<CreatedPrescriptionT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await createPrescription(userId, request, config);
  return lotusHealthZod.createPrescriptionResponse.parse(response.data) as CreatedPrescriptionT;
}
